module.exports = __webpack_public_path__ + "img/1.cdb996ba.svg";